<template>
   <CollapseCard
      title="Company Questionnaires"
      :subtitle="hasOpenStudy ? `${companyQuestionnaires.length} Questionnaires` : null"
      ident="company-questionnaire"
   >
      <div v-if="hasOpenStudy">
         <div class="px-3 d-flex justify-content-end">
            <b-button
               v-if="isSectionCompleted"
               id="btn-unlock-questionnaires"
               size="sm"
               variant="primary"
               class="action-btn"
               @click="unlockSection"
            >
               Unlock
            </b-button>
            <b-button
               v-else
               id="btn-complete-questionnaires"
               size="sm"
               variant="success"
               class="action-btn"
               :disabled="!readyToCompleteSection"
               @click="completeSection"
            >
               Mark Section Complete
            </b-button>
            <b-button
               id="btn-add-company-questionnaire"
               size="sm"
               variant="primary"
               class="action-btn ml-2"
               :to="{
                  name: 'company-questionnaire-create',
                  params: {id: $companyId},
               }"
            >
               Add New Questionnaire
            </b-button>
         </div>

         <b-table
            id="table-company-questionnaires"
            class="mt-3 mb-0"
            thead-class="table-head"
            :fields="fields"
            :items="companyQuestionnaires"
            sort-by="title"
         >
            <template #cell(title)="data">
               <div class="d-flex align-items-center">
                  <b-icon-circle-fill
                     class="mr-2"
                     :variant="questionnaireStatus(data.item).variant"
                  ></b-icon-circle-fill>
                  {{ data.value }}
               </div>
            </template>

            <template #cell(actions)="data">
               <div class="cell-w-buttons justify-content-end">
                  <b-button
                     v-if="isRndig && questionnaireStatus(data.item).text === 'Not Started'"
                     id="btn-delete-company-questionnaire"
                     variant="danger"
                     size="sm"
                     @click="deleteQuestionnaire(data.item)"
                  >
                     Delete
                  </b-button>
                  <b-button
                     id="btn-edit-company-questionnaire"
                     variant="primary"
                     size="sm"
                     class="ml-2"
                     :to="{
                        name: 'company-questionnaire-edit',
                        params: {questionnaireId: data.item.id},
                     }"
                  >
                     Edit
                  </b-button>
                  <b-button
                     id="btn-view-company-questionnaire"
                     variant="primary"
                     size="sm"
                     class="ml-2"
                     :to="{
                        name: 'company-questionnaire-complete',
                        params: {id: $companyId, questionnaireId: data.item.id},
                     }"
                  >
                     View
                  </b-button>
               </div>
            </template>
         </b-table>
      </div>

      <b-alert :show="!hasOpenStudy" variant="primary" class="m-3">
         This company does not have an open study. Open a study to configure company questionnaires.
      </b-alert>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   data() {
      return {
         fields: [
            {key: 'title', sortable: true},
            {
               key: 'status',
               formatter: (value, key, item) => this.questionnaireStatus(item).text,
               sortable: true,
               sortByFormatted: true,
               class: 'no-wrap',
            },
            {key: 'actions', label: ''},
         ],
      };
   },

   computed: {
      ...mapGetters({
         isRndig: 'isRndig',
         hasOpenStudy: 'companies/hasOpenStudy',
         companyQuestionnaires: 'questionnaire/companyQuestionnaires',
         isSectionCompleted: 'questionnaire/isSectionCompleted',
         readyToCompleteSection: 'questionnaire/readyToCompleteSection',
      }),
   },

   methods: {
      questionnaireStatus(questionnaire) {
         if (questionnaire.completed !== null) {
            return {
               text: 'Completed',
               variant: 'success',
            };
         }

         let hasAnswer = false;
         questionnaire.questions.forEach((question) => {
            hasAnswer = hasAnswer || question.answers.length > 0;
         });

         if (hasAnswer) {
            return {
               text: 'In Progress',
               variant: 'warning',
            };
         } else {
            return {
               text: 'Not Started',
               variant: 'danger',
            };
         }
      },

      deleteQuestionnaire(questionnaire) {
         this.$emit('deleteQuestionnaire', questionnaire);
      },

      async unlockSection() {
         const msg =
            "Unlocking this section may delay your credit calculation. You will have to mark it complete again once you're done.";
         const title = 'Unlock this section?';
         const proceed = await this.$bvModal.msgBoxConfirm(msg, {
            title,
            centered: true,
         });
         if (!proceed) return;

         await this.blockingRequest('questionnaire/unlockSection', {
            companyId: this.$companyId,
         });
      },

      async completeSection() {
         await this.blockingRequest('questionnaire/completeSection', {
            companyId: this.$companyId,
         });
      },
   },
};
</script>
